import React from 'react';

interface EmptyStateProps {
  title: string;
  description: string;
  icon?: React.ReactNode;
  action?: React.ReactNode;
  variant?: 'default' | 'error' | 'info';
}

export default function EmptyState({ 
  title, 
  description, 
  icon, 
  action, 
  variant = 'default' 
}: EmptyStateProps) {
  const getVariantStyles = () => {
    switch (variant) {
      case 'error':
        return {
          container: 'bg-red-50 border-red-200',
          icon: 'text-red-400',
          title: 'text-red-800',
          description: 'text-red-600'
        };
      case 'info':
        return {
          container: 'bg-blue-50 border-blue-200',
          icon: 'text-blue-400',
          title: 'text-blue-800',
          description: 'text-blue-600'
        };
      default:
        return {
          container: 'bg-gray-50 border-gray-200',
          icon: 'text-gray-400',
          title: 'text-gray-800',
          description: 'text-gray-600'
        };
    }
  };

  const styles = getVariantStyles();

  return (
    <div className={`rounded-lg border p-8 text-center ${styles.container}`}>
      {icon && (
        <div className={`mx-auto h-12 w-12 mb-4 ${styles.icon}`}>
          {icon}
        </div>
      )}
      <h3 className={`text-lg font-medium mb-2 ${styles.title}`}>
        {title}
      </h3>
      <p className={`text-sm mb-4 ${styles.description}`}>
        {description}
      </p>
      {action && (
        <div className="flex justify-center">
          {action}
        </div>
      )}
    </div>
  );
} 